module.exports = __webpack_public_path__ + "img/skip-end.47893892.svg";